module.exports = __webpack_public_path__ + "media/images/landing/en/create-93fdf1a37de9d56fbfd66c3e9573a4cb.png";